const messages = {
  'auth/email-already-in-use': 'Un compte existe déjà avec cette adresse e-mail.',
  'auth/invalid-email': 'L’adresse e-mail saisie est invalide.',
  'auth/weak-password': 'Le mot de passe doit contenir au moins 8 caractères.',
  'auth/user-not-found': 'Aucun compte ne correspond à cette adresse e-mail.',
  'auth/wrong-password': 'L’adresse e-mail ou le mot de passe est incorrect.',
  'auth/invalid-login-credentials': 'L’adresse e-mail ou le mot de passe est incorrect.',
  'auth/user-disabled': 'Ce compte a été désactivé. Contactez le support.',
  'auth/too-many-requests': 'Trop de tentatives. Patientez quelques minutes avant de réessayer.',
  'auth/network-request-failed': 'Connexion impossible. Vérifiez votre accès à Internet.',
  'auth/requires-recent-login': 'Pour votre sécurité, reconnectez-vous avant cette opération.',
  'auth/password-required': 'Saisissez votre mot de passe pour confirmer la suppression.',
  'functions/unauthenticated': 'Votre session a expiré. Reconnectez-vous.',
  'functions/failed-precondition': 'Cette opération ne peut pas être effectuée dans l’état actuel du compte ou du projet.',
  'functions/permission-denied': 'Votre compte n’est pas autorisé à effectuer cette opération.',
  'functions/internal': 'Le service a rencontré une erreur technique. Rechargez la page puis réessayez. Si elle persiste, vérifiez que toutes les fonctions LPB ont été redéployées.',
  'functions/unavailable': 'Le service LPB est momentanément indisponible. Réessayez dans quelques instants.',
  'functions/invalid-argument': 'Certaines informations envoyées sont invalides ou incomplètes.',
  'functions/not-found': 'Le projet ou le compte demandé n’existe plus.',
  'auth/operation-not-allowed': 'L’inscription par adresse e-mail et mot de passe n’est pas activée dans Firebase.',
  'auth/unauthorized-continue-uri': 'Le domaine de retour n’est pas autorisé dans Firebase Authentication.',
  'auth/invalid-continue-uri': 'L’adresse de retour configurée pour l’e-mail est invalide.',
  'auth/missing-continue-uri': 'L’adresse de retour de l’e-mail de sécurité est manquante.',
  'auth/quota-exceeded': 'La limite temporaire d’envoi d’e-mails Firebase a été atteinte. Réessayez plus tard.',
  'auth/app-not-authorized': 'Cette application Web n’est pas autorisée à utiliser ce projet Firebase.',
  'auth/invalid-api-key': 'La clé API Firebase utilisée par le site est invalide.',
  'permission-denied': 'Firebase a refusé l’écriture du profil. Vérifiez les règles Firestore déployées.',
  'firestore/permission-denied': 'Firebase a refusé l’écriture du profil. Vérifiez les règles Firestore déployées.',
  unavailable: 'Le service Firebase est momentanément indisponible. Réessayez dans quelques instants.',
};

export const getFirebaseErrorMessage = (error) => {
  if (!error) return 'Une erreur inattendue est survenue.';
  const code = String(error.code || '');
  const raw = String(error.message || '').trim();

  // Callable functions carry the authoritative workflow explanation. Preserve
  // it whenever it is meaningful, including trace references returned by the
  // hardened backend. Never expose Firebase's opaque "internal" text.
  if (code.startsWith('functions/')) {
    if (code === 'functions/internal' || /^internal$/i.test(raw)) {
      return messages['functions/internal'];
    }
    if (raw && !/^missing or insufficient permissions[.]?$/i.test(raw)) return raw;
    return messages[code] || 'Le service LPB n’a pas pu terminer cette opération.';
  }

  if (code && messages[code]) return messages[code];
  if (/^missing or insufficient permissions[.]?$/i.test(raw)) {
    return 'Firebase a refusé cette lecture ou écriture. Rechargez l’application après le déploiement des règles LPB.';
  }
  return raw || 'Une erreur inattendue est survenue.';
};
